import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { CheckTaskAction } from 'src/@allxs/store/actions/task.action';

export const PaymentResolver: ResolveFn<boolean> = (route, state) => {
  return inject(Store).dispatch(new CheckTaskAction(route.paramMap.get('slug')!));
};
